export { default } from "./ScopedCssBaseline.js";
export { default as scopedCssBaselineClasses } from "./scopedCssBaselineClasses.js";
export * from "./scopedCssBaselineClasses.js";